// account
export const LOGIN = 'login';
export const LOGIN_OAUTH = 'loginOAuth';
export const SIGNUP = 'signup';
export const SIGNUP_OAUTH = 'signupOAuth';
export const LOGOUT = 'logout';
export const UPDATE_ACCOUNT = 'updateAccount';
export const FORGOT_PASSWORD = 'forgotPassword';
export const RESET_PASSWORD = 'resetPassword';
export const RESET_PASSWORD_AUTHED = 'resetPasswordAuthed';
export const SET_PASSWORD_AND_VERIFY = 'resetPasswordAndVerify';
export const REQUEST_SET_PASSWORD_AND_VERIFY = 'requestSetPasswordAndVerify';
export const GET_AUTH_ACCOUNT = 'getAuthAccount';
export const REQUEST_EMAIL_VERIFICATION = 'requestEmailVerification';
export const VERIFY_EMAIL = 'verifyEmail';
export const CLEAR_ACCOUNT_ISLOADING = 'clearAccountIsLoading';

// organization
export const REGISTER_ORGANIZATION = 'registerOrganization';
export const SIGNUP_ORGANIZATION = 'signupOrganization';
export const GET_ORGANIZATIONS = 'getOrganizations';
export const GET_ORGANIZATION = 'getOrganization';
export const GET_ORGANIZATION_STATS = 'getOrganizationStats';
export const EDIT_ORGANIZATION = 'editOrganization';
export const TOGGLE_ORGANIZATION_IS_ACTIVE = 'toggleOrganizationIsActive';
export const SET_ORGANIZATION_ARCHIVED = 'setOrganizationArchived';
export const REQUEST_ORGANIZATION_DELETION_CODE = 'requestOrganizationDeletionCode';
export const DELETE_ORGANIZATION = 'deleteOrganization';
export const CLEAR_ORGANIZATION_ISLOADING = 'clearOrganizationIsLoading';

// users
export const GET_USERS = 'getUsers';
export const GET_USER = 'getUser';
export const GET_USER_STATS = 'getUserStats';
export const REGISTER_USER = 'registerUser';
export const INVITE_USER = 'inviteUser';
export const RESEND_USER_INVITATION = 'resendInvitation';
export const EDIT_USER = 'editUser';
export const TOGGLE_USER_IS_ACTIVE = 'toggleUserIsActive';
export const DELETE_USER = 'deleteUser';
export const CLEAR_USERS_ISLOADING = 'clearUsersIsLoading';

// screen
export const REGISTER_SCREEN = 'registerScreen';
export const GET_SCREENS = 'getScreens';
export const GET_SCREENS_UNPOPULATED = 'getScreensUnpopulated';
export const GET_SCREEN = 'getScreen';
export const EDIT_SCREEN = 'editScreen';
export const UPDATE_SCREEN_LOCATION = 'updateScreenLocation';
export const DELETE_SCREEN = 'deleteScreen';
export const CLEAR_SCREEN_ISLOADING = 'clearScreenIsLoading';

// ticket
export const ADD_TICKET = 'addTicket'
export const GET_TICKETS = 'getTickets'
export const DELETE_TICKET = 'deleteTicket'
export const EDIT_TICKET = 'editTicket'
export const CLOSE_TICKET = 'closeTicket'
export const CLEAR_TICKETS_ISLOADING = 'clearTicketsIsLoading'
export const GET_TICKET_UNREAD = 'getTicketUnread'
export const MARK_TICKET_READ = 'markTicketRead'
export const UPSERT_TICKET = 'upsertTicket'
export const CLEAR_TICKET_UNREAD = 'clearTicketUnread'
export const ASSIGN_TICKET = 'assignTicket'
export const SET_TICKET_STATUS = 'setTicketStatus'

// ticket
export const ADD_TICKET_COMMENT = 'addTicketComment'
export const GET_TICKET_COMMENTS = 'getTicketComments'
export const DELETE_TICKET_COMMENT = 'deleteTicketComment'
export const EDIT_TICKET_COMMENT = 'editTicketComment'
export const CLEAR_TICKET_COMMENTS = 'clearTicketComments'
export const CLEAR_TICKET_COMMENTS_ISLOADING = 'clearTicketCommentsIsLoading'

// sidenav
export const UPDATE_SIDENAV = 'updateSidenav';
export const CLEAR_SIDENAV = 'clearSidenav';

// router_loader
export const UPDATE_ROUTER_LOADER = 'updateRouterLoader';
export const CLEAR_ROUTER_LOADER = 'clearRouterLoader';

// error
export const CLEAR_ERRORMSG = 'clearErrorMessage';
export const UPDATE_ERRORMSG = 'updateErrorMessage';

// activity log
export const GET_ACTIVITY_LOGS = 'getActivityLogs';

// dashboard
export const GET_DASHBOARD = 'getDashboard';

// support session (see utils/support_session)
export const OPEN_SUPPORT_SESSION_LAUNCHER = 'openSupportSessionLauncher';
export const CLOSE_SUPPORT_SESSION_LAUNCHER = 'closeSupportSessionLauncher';
export const START_SUPPORT_SESSION = 'startSupportSession';
export const END_SUPPORT_SESSION = 'endSupportSession';
export const RELEASE_SUPPORT_SESSION = 'releaseSupportSession';
export const DISMISS_SUPPORT_SESSION = 'dismissSupportSession';
export const CHECK_SUPPORT_SESSION = 'checkSupportSession';
export const NOTE_SUPPORT_SESSION_PATH = 'noteSupportSessionPath';

// organization settings
export const SET_ORGANIZATION_APPS = 'setOrganizationApps';
export const SET_ORGANIZATION_STATUS = 'setOrganizationStatus';
export const ARCHIVE_ORGANIZATION = 'archiveOrganization';
